import React, { useState } from 'react';
import { View } from 'react-native';
import { Credential } from '../../../../types/credentials';
import GenericButton from '../../../../components/molecules/GenericButton';
import DeleteConfirmModal from '../../../../components/modal/DeleteConfirmModal';
import { useTractionService } from '../../../../services';
import { useCredentialData, useToast } from '../../../../contexts';

interface CardActionsProps {
  credential: Credential;
  onRemoveCredential: () => void;
}

/**
 * CardDetails is a component that displays the details of a credential.
 * It is used in the CredentialCard component.
 *
 * @param {CardDetailsProps} { credential }
 * @return {React.FC}
 */
const CardActions: React.FC<CardActionsProps> = ({ credential, onRemoveCredential }) => {
  const service = useTractionService();
  const toast = useToast();
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);
  const { removeCredential } = useCredentialData();

  const handleRemoveCredential = async () => {
    const result = await service.removeCredential(credential.credentialExchangeId);
    setIsDeleteModalVisible(false);
    removeCredential(credential);
    onRemoveCredential();

    if (result) {
      toast.showToast('Credential removed successfully', 3000, true);
    } else {
      toast.showToast('Failed to remove credential', 3000, false);
    }
  };

  return (
    <View>
      <DeleteConfirmModal
        isVisible={isDeleteModalVisible}
        onClose={() => setIsDeleteModalVisible(false)}
        title="Are you sure you want to remove this credential?"
        onConfirm={() => handleRemoveCredential()}
      />
      <GenericButton
        title="Remove Credential"
        onPress={() => setIsDeleteModalVisible(true)}
        isPrimary={false}
      />
    </View>
  );
};

export default CardActions;
